import { Component, Input, ViewChild } from '@angular/core';
import { UtilsService } from 'app/environment/services/utils.service';
import { NgForm } from '@angular/forms';
import { IInterfacePropertiesMetadata } from 'app/connect/core/IConnectInterfacesMetadata';

@Component({
    selector: 'connect-interfaces-properties',
    templateUrl: 'connect-interfaces-properties.component.html',
    styleUrls: ['connect-interfaces-properties.component.scss']
})
export class ConnectInterfacesPropertiesComponent {

    @ViewChild('propertiesForm', { static: false}) propertiesForm: NgForm;

    @Input() selectedInterface: any;
    @Input() metadata: IInterfacePropertiesMetadata;

    constructor(public utilsService: UtilsService) { }

    public isValid(): boolean {
        return !this.propertiesForm || this.propertiesForm.valid;
    }

    public setValue(event, property) {
        if ((this.selectedInterface.environment as any).hasOwnProperty(property.key)) {
            this.selectedInterface.environment[property.key] = event;
        } else if ((this.selectedInterface.environment.security as any).hasOwnProperty(property.key)) {
            this.selectedInterface.environment.security[property.key] = event;
        }
    }
}
